import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ChartOptions, ChartDataSets } from 'chart.js';

@Component({
  selector: 'kt-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.css']
})
export class PieChartComponent implements OnInit {

  @Input() chartLabels: string[] = []; // Dynamic labels for the chart
  @Input() chartData: number[] = [];  // Dynamic data for the chart
  @Input() chartColors: string[] = []; // Optional custom colors for the chart

  public pieChartType: 'pie' = 'pie';

  // Data for Pie Chart
  public pieChartData: ChartDataSets[] = [
    {
      data: [],
      backgroundColor: [],
      hoverBackgroundColor: [],
    },
  ];

  // Options for Pie Chart
  public pieChartOptions: ChartOptions= {
    maintainAspectRatio: false,
      legend: {
        position: 'bottom',
      }
  };

  private readonly defaultColors = [
    '#FF7360', '#6FC8CE', '#F7B7A3', '#D3B8E5', '#FFD54F', '#90CAF9',
  ];

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['chartLabels'] || changes['chartData'] || changes['chartColors']) {
      // Update labels, data, and colors dynamically
      this.updateChart();
    }
  }

  private updateChart(): void {
    // Use input colors if provided, otherwise fall back to default colors
    const backgroundColors = this.chartColors.length
      ? this.chartColors
      : (this.chartData && this.chartData.map)
        ? this.chartData.map((_, index) => this.defaultColors[index % this.defaultColors.length])
        : [];


    const hoverBackgroundColors = backgroundColors.map((color) => this.adjustHoverColor(color));

    // Update chart data
    this.pieChartData = [
      {
        data: this.chartData,
        backgroundColor: backgroundColors,
        hoverBackgroundColor: hoverBackgroundColors,
      },
    ];
  }

  private adjustHoverColor(color: string): string {
    // Darken the color for hover effect
    const amount = 20; // Increase this value for a darker effect
    return this.darkenColor(color, amount);
  }
  
  private darkenColor(color: string, percent: number): string {
    const num = parseInt(color.slice(1), 16); // Convert hex color to a number
    const r = Math.max(0, (num >> 16) - percent); // Decrease red component
    const g = Math.max(0, ((num >> 8) & 0x00ff) - percent); // Decrease green component
    const b = Math.max(0, (num & 0x0000ff) - percent); // Decrease blue component
    return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
  }

}
